var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddContactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2599 8C16.4699 8 18.2599 6.21 18.2599 4C18.2599 1.79 16.4699 0 14.2599 0C12.0499 0 10.2599 1.79 10.2599 4C10.2599 6.21 12.0499 8 14.2599 8ZM5.25986 6V4C5.25986 3.45 4.80986 3 4.25986 3C3.70986 3 3.25986 3.45 3.25986 4V6H1.25986C0.709857 6 0.259857 6.45 0.259857 7C0.259857 7.55 0.709857 8 1.25986 8H3.25986V10C3.25986 10.55 3.70986 11 4.25986 11C4.80986 11 5.25986 10.55 5.25986 10V8H7.25986C7.80986 8 8.25986 7.55 8.25986 7C8.25986 6.45 7.80986 6 7.25986 6H5.25986ZM14.2599 10C11.5899 10 6.25986 11.34 6.25986 14V15C6.25986 15.55 6.70986 16 7.25986 16H21.2599C21.8099 16 22.2599 15.55 22.2599 15V14C22.2599 11.34 16.9299 10 14.2599 10Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContactIcon);
export default __webpack_public_path__ + "static/media/AddContactIcon.40635a65d7b5a8e95467e96bae2e5e85.svg";
export { ForwardRef as ReactComponent };